import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const convertToDataTable = (data: IGetAtmCompany[]): IGetAtmCompany[] => {
  const dataTableData: IGetAtmCompany[] = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d)
  })

  return dataTableData;
}

const getAllAtmCompaniesList = async (): Promise<IGetAtmCompany[]> => {
  const response =  await axiosDefaultApi.get(`/api/AtmCompanies/GetAtmCompanies` );
  return convertToDataTable(response as unknown as IGetAtmCompany[]);
};

type QueryFnType = typeof getAllAtmCompaniesList;

type UseGetAllAtmCompaniesListOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllAtmCompaniesList = ({ config }: UseGetAllAtmCompaniesListOptions = {} ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllAtmCompaniesList'],
    queryFn: () => getAllAtmCompaniesList(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};